import React from 'react';
import {
  Button as CoreButton,
  Modal as CoreModal,
} from '@tangibleplay/core-ui';

import { verifyAddressPopupCustomStyle } from './VerifyAddressPopup.styles';

import { VerifyAddressPopupProps } from './VerifyAddressPopup.types';

const VerifyAddressPopup = ({
  modalComponent: Modal = CoreModal,
  buttonComponent: Button = CoreButton,
  modalProps = {},
  buttonPropsList = [],
  titleSlot,
  addressSlot,
  componentClassname = 'verify-address-popup',
  customClassnames = '',
  customStyle = '',
}: VerifyAddressPopupProps) => {
  return (
    <Modal
      customClassnames={`${componentClassname} ${customClassnames}`}
      customStyle={`${verifyAddressPopupCustomStyle} ${customStyle}`}
      canOverlayClickCloseModal={false}
      hasButtonClose={false}
      {...modalProps}
    >
      {titleSlot && (
        <div className={`${componentClassname}__title-wrapper`}>
          {titleSlot}
        </div>
      )}
      {addressSlot && (
        <div className={`${componentClassname}__address-wrapper`}>
          {addressSlot}
        </div>
      )}
      {!!buttonPropsList?.length && (
        <ul className={`${componentClassname}__button-list-wrapper`}>
          {buttonPropsList.map((buttonProps, index) => (
            <li key={index}>
              <Button {...buttonProps} />
            </li>
          ))}
        </ul>
      )}
    </Modal>
  );
};
VerifyAddressPopup.displayName = 'VerifyAddressPopup';

export default VerifyAddressPopup;
